import { Gameplay, eBatchGroup, TIMER, eState } from "../../Gameplay";
import { ViewCellMapRow } from "../View/ViewCellMapRow";
import { eModelAsset, Game } from "../../../Game";
import { IDictionary } from "../../../Utils/Collections/Dictionary";
import { TileBase } from "../Ground Tiles/TileBase";
import { ViewCellMap } from "../View/ViewCellMap";
import { View } from "../View/View";
import { Rectangle } from "../../../Utils/2D Shapes/Rectangle";
import { Pool } from "../../../Utils/Collections/Pool";



export const enum ePlatformState {
    atStartPos,
    moving,
    atEndPos,
}



export class Platform {
    /**
     * Assety s modely pro jednotlive verze plosin
     */
    private static _MODEL_ASSETS: IDictionary<pc.Asset>;

    private _entity: pc.Entity;

    /**
     * Sirka plosiny v poctu dlazdic
     */
    private _width: number;

    /**
     * Index prvni bunky v radce
     */
    private _cellId: number;

    /**
     * (RO) Aktualni stav
     */
    get state(): ePlatformState { return this._state; }
    private _state: ePlatformState;

    /**
     * Rychlost pohybu plosiny v jednotkach za vterinu
     */
    private static readonly MOVE_SPEED = 8;

    /**
     * (RO) Velikost kroku, o ktery se plosina presunula pri poslednim update()
     */
    get moveStep(): number { return this._movStep; }
    private _movStep: number;

    /**
     * Cilova radka plosiny (nastavi se pri aktivaci plosiny)
     */
    private _targetRow: ViewCellMapRow;

    /**
     * MeshInstance s overlay, ktere se zobrazi po najeti hrace na plosinu
     */
    private _overlay: pc.MeshInstance;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        if (!Platform._MODEL_ASSETS) {
            // Assety pro plosiny
            Platform._MODEL_ASSETS = {};
            Platform._MODEL_ASSETS["1"] = Game.app.assets.find(eModelAsset.platform1, pc.ASSET_MODEL);
            Platform._MODEL_ASSETS["2"] = Game.app.assets.find(eModelAsset.platform2, pc.ASSET_MODEL);
        }

        // Vytvorit entitu
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.asset,
            batchGroupId: Gameplay.BATCH_GROUP_ID[eBatchGroup.solid_0],
            castShadows: false,
            castShadowsLightmap: false,
            receiveShadows: false,
            lightmapped: false,
        });
        this._entity.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(width: number, cellId: number, row: ViewCellMapRow): void {
        this._cellId = cellId;
        this._targetRow = row;

        // Nastavit entitu
        if (width != this._width) {
            this._width = width;
            this._entity.model.asset = Platform._MODEL_ASSETS[width.toString()];
            this._overlay = this._entity.model.meshInstances[1];
        }

        this._entity.setLocalPosition(cellId * TileBase.SIZE + width / 2, 0, 0);
        this._overlay.visible = false;

        let rowGraphNode = row.graphNode;

        if (this._entity.parent != rowGraphNode)
            this._entity.reparent(rowGraphNode);

        this._entity.enabled = true;

        // Stav
        this._state = ePlatformState.atStartPos;

        // Ulozit referenci do jednotlivych bunek
        let i = width;

        while (i-- != 0)
            row.getCell(cellId + i).platform = this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    release(): void {
        if (this._entity.enabled)
            this._entity.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        if (!this._entity.enabled)
            return false;

        let pos = this._entity.getPosition();

        if (this._state == ePlatformState.moving) {
            // Aktualizovat pozici na Z
            this._movStep = Platform.MOVE_SPEED * TIMER.deltaS;

            if (pos.z - this._movStep <= this._targetRow.z) {
                // Plosina dorazila do cilove pozice
                this._movStep = pos.z - this._targetRow.z;
                this._state = ePlatformState.atEndPos;

                let i = this._width;

                while (i-- != 0)
                    this._targetRow.getCell(this._cellId + i).platform = this;

                this._overlay.visible = false;
            }

            pos.z -= this._movStep;
            this._entity.setPosition(pos);
        }
        else if (this._state == ePlatformState.atEndPos) {
            if (pos.z - TileBase.SIZE / 2 >= View.instance.botZ)
                return false;
        }

        return true;
    }

    //-------------------------------------------------------------------------
    /**
     * Zahajeni pohybu plosiny
     */
    //-------------------------------------------------------------------------
    activate(): void {
        if (this._state != ePlatformState.atStartPos)
            return;

        this._state = ePlatformState.moving;

        // Odebrat plosinu z radky a premistit ji do rootu
        let pos = this._entity.getPosition();

        this._entity.reparent(Game.app.root);
        this._entity.setPosition(pos);

        let i = this._width;
        let row = this._targetRow;

        while (i-- != 0)
            row.getCell(this._cellId + i).platform = undefined;

        // Zobrazit overlay
        this._overlay.visible = true;

        // Najit cilovou radku
        let map = ViewCellMap.instance;
        let z = this._targetRow.z - TileBase.SIZE;

        while (true) {
            row = map.getRow(z);

            if (row && row.getCell(this._cellId)) {
                this._targetRow = row;
                break;
            }

            z -= TileBase.SIZE;
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Vypocita kolizni obdelnik pro plosinu
     * @param rect Objekt, do ktereho se data zapisi
     */
    //-------------------------------------------------------------------------
    getColRect(rect: Rectangle): void {
        let pos = this._entity.getPosition();
        let w = this._width * TileBase.SIZE;

        rect.setTo(pos.x - w / 2, pos.z - TileBase.SIZE / 2, w, TileBase.SIZE);
    }
}